<script>
import Onboarding from '../../components/onboarding/Onboarding.vue';
import RedefinePasswordForm from '../../components/form/RedefinePasswordForm.vue';

export default {
  components: { Onboarding, RedefinePasswordForm },
  computed: {
    isMobileScreen() {
      return window.innerWidth < 768;
    },
  },
  created() {
    this.code = this.$router.history.current.params.code;
  },
  methods: {
    handleRedirectToSignIn() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "signin",
        params,
      });
    },
    async doResetPassword() {
      try {
        if (this.password == "" && this.password_confirmation == "") {
          this.$vs.notify({
            title: "Verifique as senhas",
            text: "É necessário preencher o campo senha e confirmação de senha",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
          return;
        }

        if (this.password == this.password_confirmation) {
          this.$vs.loading({
            text: "Salvando...",
          });

          const payload = {
            password: this.password,
            password_confirmation: this.password_confirmation,
          };

          const response = await this.$http.post(
            `api/v1/reset/password/${this.code}`,
            payload
          );

          if (response.status == 200) {
            this.$vs.loading.close();

            localStorage.setItem("last_login_method", "password");

            this.sended = true;

            this.$vs.notify({
              title: "Parabéns!",
              text: "Sua senha foi alterada com sucesso",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
            });
          }

          if (response.status == 400) {
            this.$vs.loading.close();
          }
        } else {
          this.$vs.notify({
            title: "Verifique as senhas",
            text: "As senhas informadas não são iguais",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Falha ao resetar a senha",
          text:
            error.message ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
  },
};
</script>

<template>
  <div v-if="!isMobileScreen" class="redefine-password">
    <div class="redefine-password__letfside bg-primary-opacity">
      <onboarding />
    </div>
    <div class="redefine-password__rightside">
      <redefine-password-form />
    </div>
  </div>
  <div v-else class="redefine-password">
    <div class="redefine-password__mobile--wrapper">
      <redefine-password-form />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.redefine-password {
  display: flex;
  width: 100%;
  height: 100vh;

  &__letfside {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
  }

  &__rightside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 100vh;
    min-width: 440px;
    padding: 0 40px;
  }

  &__mobile--wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 8px;
    align-self: center;
    justify-self: center;
  }

  &__mobile--wrapper > button {
    margin: 22px 13px;

    @media (max-width: 599px) {
      margin: 15px 13px;
    }
  }

  &__mobile--wrapper > p {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    text-align: center;
  }
}
</style>
